var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("疗养预约系统")]),
            _c("el-breadcrumb-item", [_vm._v("公告信息")]),
            _c("el-breadcrumb-item", [_vm._v("发布公告")]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "hx-form-container box-shadow" },
      [
        _c(
          "el-form",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading",
              },
            ],
            attrs: { model: _vm.listParams, rules: _vm.checklistParams },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "公告标题：" } },
              [
                _c("el-input", {
                  staticStyle: { width: "200px" },
                  attrs: { size: "small", placeholder: "输入标题" },
                  model: {
                    value: _vm.listParams.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.listParams, "title", $$v)
                    },
                    expression: "listParams.title",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticStyle: { height: "650px" },
                attrs: { label: "公告内容：", prop: "description" },
              },
              [
                _c("RichTextarea", {
                  staticClass: "wang-editor-style",
                  attrs: { height: "540px" },
                  model: {
                    value: _vm.listParams.content,
                    callback: function ($$v) {
                      _vm.$set(_vm.listParams, "content", $$v)
                    },
                    expression: "listParams.content",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "align-center mgt10",
                staticStyle: { "padding-bottom": "20px", "margin-top": "20px" },
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.saveAdd()
                      },
                    },
                  },
                  [_vm._v(" 保存 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "mgl20",
                    attrs: { size: "small" },
                    on: { click: _vm.backToList },
                  },
                  [_vm._v("返回")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }